'use client';

import dynamic from 'next/dynamic';

import { useAppContext } from '../AppProvider';

const EzShipSidebar = dynamic(() => import('@/components/EzShip/Sidebar'));

const Bootstrap: React.FC = () => {
  const { isEzShipSidebarVisible, setVisibilityOfEzShipSidebar } = useAppContext();
  return (
    <>
      {isEzShipSidebarVisible && (
        <EzShipSidebar isOpen={isEzShipSidebarVisible} onClose={() => setVisibilityOfEzShipSidebar(false)} />
      )}
    </>
  );
};

export default Bootstrap;
